import { get, patch } from "../../api/api";
import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';

// Listar parametros locais
export const listarParametrosLocais = async (id: string) => {
  return await get<IRespostaFuncao<any>>(`empresas/${id}/parametros-locais`);
};

// Atualizar parametros locais
export const atualizarParametrosLocais = async (
  id: string,
  payload: any,
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/empresas/${id}/parametros-locais/atualiza-parametros-locais`,
    payload
  );
};